import apiClient from '../service/api'

export interface Promotion {
  id: number
  serviceType: string
  name: string | null
  discountRate: number
  startedAt: string
  expiredAt: string
  active: boolean
  createdAt: string
  updatedAt: string
}

export interface PromotionFormData {
  serviceType: string
  name?: string
  discountRate: number
  startedAt: string
  expiredAt: string
}

export const getPromotions = async (): Promise<Promotion[]> => {
  const { data } = await apiClient.get('/v1/promotions')
  return data.data
}

export const getPromotion = async (id: number): Promise<Promotion> => {
  const { data } = await apiClient.get(`/v1/promotions/${id}`)
  return data.data
}

export const createPromotion = async (body: PromotionFormData): Promise<Promotion> => {
  const { data } = await apiClient.post('/v1/promotions', body)
  return data.data
}

export const updatePromotion = async (id: number, body: PromotionFormData): Promise<Promotion> => {
  const { data } = await apiClient.put(`/v1/promotions/${id}`, body)
  return data.data
}

export const deletePromotion = async (id: number): Promise<void> => {
  await apiClient.delete(`/v1/promotions/${id}`)
}
